import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function AboutSection() {
  const features = ['Custom Design for Every Property', 'Premium Materials & Fixtures', 'Transparent Pricing, No Surprises'];
  return <section className="w-full bg-[var(--brand-black)] py-20 lg:py-28 overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-3">
          {/* Image Column */}
          <div className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="absolute -inset-4 bg-[var(--brand-gold)]/20 rounded-lg transform -rotate-3" data-id="element-5"></div>
            <img src="https://cdn.magicpatterns.com/uploads/88n9H6duUfUREiU7nFn7S1/landscape-lights.webp" alt="Beautifully lit property at night" className="relative w-full h-auto object-cover rounded-lg shadow-2xl" data-id="element-6" />
          </div>

          {/* Content Column */}
          <div className="w-full lg:w-1/2 flex flex-col items-start" data-id="element-7">
            <span className="text-[var(--brand-gold)] font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-8">
              About Love Outdoor Lighting
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-wider mb-6 leading-tight" data-id="element-9">
              Arizona Natives.
              <br data-id="element-10" />
              Design-Driven.
              <br data-id="element-11" />
              Built on Integrity.
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-12">
              We're not just another lighting company — we take a design-driven
              approach that separates us from the competition. Every project is
              guided by timeless values: transparency, integrity, and hard work.
              From concept to installation, we treat your property like our own.
            </p>

            <ul className="space-y-4 mb-10 w-full" data-id="element-13">
              {features.map((feature, index) => <li key={index} className="flex items-center text-white text-lg" data-id="element-14">
                  <CheckCircle2 className="w-6 h-6 text-[var(--brand-gold)] mr-4 flex-shrink-0" data-id="element-15" />
                  <span data-id="element-16">{feature}</span>
                </li>)}
            </ul>

            <Button size="lg" className="w-full sm:w-auto bg-[var(--brand-green)] hover:bg-green-700 text-white font-medium text-lg h-14 px-8" data-id="element-17">
              Get Your Free Quote
            </Button>
          </div>
        </div>
      </div>
    </section>;
}